function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
import * as Styled from './PlayerWaveform.styles';
import { usePlayer, usePlayerAudio } from '../../hooks';
import Waveform from './core/Waveform';
import { formatTime } from '../../utils';
var PlayerWaveform = function PlayerWaveform() {
  var _usePlayer = usePlayer(),
    currentTrack = _usePlayer.currentTrack,
    playNextTrack = _usePlayer.playNextTrack;
  var _usePlayerAudio = usePlayerAudio(),
    audioElement = _usePlayerAudio.audioElement;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    duration = _useState2[0],
    setDuration = _useState2[1];
  var currentTimeRef = useRef(null);
  var progressBarRef = useRef(null);
  useEffect(function () {
    var handleDurationChange = function handleDurationChange() {
      if (audioElement) setDuration(audioElement.duration);
    };
    var handleTimeUpdate = function handleTimeUpdate() {
      if (audioElement && currentTimeRef.current) {
        var currentTime = audioElement.currentTime;
        currentTimeRef.current.textContent = formatTime(currentTime);
        progressBarRef.current.style.width = "".concat(currentTime / audioElement.duration * 100, "%");
      }
    };
    if (audioElement && currentTrack) {
      audioElement.addEventListener('durationchange', handleDurationChange);
      audioElement.addEventListener('timeupdate', handleTimeUpdate);
      audioElement.addEventListener('ended', playNextTrack);
    }
    return function () {
      if (audioElement) {
        audioElement.removeEventListener('durationchange', handleDurationChange);
        audioElement.removeEventListener('timeupdate', handleTimeUpdate);
        audioElement.removeEventListener('ended', playNextTrack);
      }
    };
  }, [audioElement, currentTrack, playNextTrack]);
  if (!currentTrack || !audioElement) return null;
  return /*#__PURE__*/React.createElement(Styled.WaveformContainer, null, /*#__PURE__*/React.createElement(Styled.Time, {
    variant: "bodyS",
    ref: currentTimeRef,
    "data-testid": "player-track-time"
  }, formatTime(0)), /*#__PURE__*/React.createElement(Styled.Waveform, null, /*#__PURE__*/React.createElement(Waveform, {
    track: currentTrack
  })), /*#__PURE__*/React.createElement(Styled.ProgressBarContainer, null, /*#__PURE__*/React.createElement(Styled.ProgressBar, {
    ref: progressBarRef
  })), /*#__PURE__*/React.createElement(Styled.Duration, {
    variant: "bodyS",
    "data-testid": "player-track-duration"
  }, formatTime(duration)));
};
export default /*#__PURE__*/React.memo(PlayerWaveform);